import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'

// Suppress harmless COOP warnings from Firebase Auth popup flow
// This is a browser security warning that doesn't affect functionality
const originalError = console.error;
console.error = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  const fullMessage = args.map(arg => String(arg)).join(' ');
  
  // Suppress all COOP-related warnings from Firebase Auth
  if (
    message.includes('Cross-Origin-Opener-Policy') ||
    fullMessage.includes('Cross-Origin-Opener-Policy') ||
    message.includes('window.close') ||
    message.includes('window.closed') ||
    fullMessage.includes('window.close') ||
    fullMessage.includes('window.closed') ||
    fullMessage.includes('policy would block')
  ) {
    // Suppress these warnings - they're harmless and don't affect functionality
    return;
  }
  originalError.apply(console, args);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)


